const WEEK = 7

export function ratio(part: number, whole: number): number | null {
  if (!(whole > 0)) return null
  return part / whole
}

export function weekOverWeek(daily: readonly number[]): number | null {
  if (daily.length < 2 * WEEK) return null
  const sum = (values: readonly number[]) => values.reduce((total, value) => total + value, 0)
  const current = sum(daily.slice(-WEEK))
  const previous = sum(daily.slice(-2 * WEEK, -WEEK))
  if (!(previous > 0)) return null
  return (current - previous) / previous
}

export function formatChange(change: number, locale: string): string {
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    signDisplay: 'exceptZero',
    maximumFractionDigits: 0,
  }).format(change)
}

export type GuestWeekKey = 'converted' | 'stillGuest'

export function guestWeekBars(
  weekly: readonly { week: string; guests: number; converted: number }[],
): { date: string; values: Record<GuestWeekKey, number> }[] {
  return weekly.map((entry) => {
    const converted = Math.min(entry.converted, entry.guests)
    return {
      date: entry.week,
      values: { converted, stillGuest: Math.max(0, entry.guests - converted) },
    }
  })
}
